import Vue from 'vue'
import VueRouter from 'vue-router'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import axios from 'axios'
import Element from 'element-ui'
import './styles/element-variables.scss'
import './utils/select-load'
import DataV from '@jiaminghi/data-view'
import uploadFilePopover from '@/components/UploadFilePopover'
import { decryptionObj } from '@/utils/crypto'

import Print from 'vue-print-nb'

import '@/styles/index.scss' // global css
import echarts from 'echarts'
import App from './App'
import store from './store'
import router from './router'
import './icons' // icon
import i18n from './lang' // internationalization
import './permission' // permission control
import './utils/error-log' // error log
import * as filters from './filters' // global filters
import waves from '@/directive/waves/index'
import decimal from '@/directive/input-decimal/decimal'
import '@/directive/preventReClick'
// import Print from 'vue-print-nb'
// import print from './plugins/print/print'

import Mixin from './mixins'
import _ from 'lodash'
import './utils/store'
import * as inputRules from '@/utils/inputRules'
// 输入规则

import * as validators from '@/utils/validator'// 输入框规则校验文件
import reportPrintJS from '@/utils/ReportPrint/src/index'
import directive from './directive'

import Components from '@/components'

Vue.use(VueRouter)

Vue.prototype.validators = validators

Vue.prototype.$reportPrintJS = reportPrintJS

Vue.prototype.decryptionMethods = decryptionObj

Vue.use(DataV)
Vue.prototype.$axios = axios
Vue.use(Print)
Vue.prototype.$echarts = echarts// 工具类
Vue.prototype.inputRules = inputRules
Vue.prototype.$reportPrintJS = reportPrintJS

Vue.prototype._ = _
Vue.mixin(Mixin)
// Vue.use(print);
// Vue.use(print);
waves.install(Vue)

Vue.use(uploadFilePopover)
Vue.use(directive)
Vue.directive('decimal', decimal)
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
Vue.use(Element, {
	size: Cookies.get('size') || 'medium', // set element-ui default size
	i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Components)
// register global utility filters
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.prototype.accMul = (arg1, arg2) => {
	console.log(arg1)
	if (arg1 !== 0 && !arg1) return ''
	let m = 0
	const s1 = arg1.toString()
	const s2 = arg2.toString()
	try {
		m += s1.split('.')[1].length
	} catch (e) {}
	try {
		m += s2.split('.')[1].length
	} catch (e) {}
	return (
		(Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
	)
}
const debug = true
if (!debug) {
	console.log = function () {
		return false
	}
}

// router.afterEach((to, from) => {
//   // to and from are both route objects.
//   if(_paq) {
//     // _paq.push(['setCustomVariable', 1, 'title', to.name])
//     // _paq.push(['setCustomVariable', 2, 'path', to.path])
//     _paq.push(['trackPageView', to.name])
//   }
// })

new Vue({
	el: '#app',
	router,
	store,
	i18n,
	render: h => h(App)
})
